import { createContext, useContext } from "react";

export const CONTACT = {
  email: "tsmway7@gmail.com",
  phone: "+39 352 072 2207",
  phoneRaw: "+393520722207",
  whatsapp: "https://wa.me/393520722207",
  phoneTn: "+216 92 851 972",
  whatsappTn: "https://wa.me/21692851972",
  facebook: "https://www.facebook.com/share/1Dj7YM555j/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/tsm.way",
};

export const LangContext = createContext({ lang: "it", t: {} , setLang: () => {} });
export const useLang = () => useContext(LangContext);

const it = {
  nav: { desertCall: "Desert Call", moto: "Tour Moto", fourx4: "Tour 4X4", routes: "Itinerari", gallery: "Galleria", about: "Chi siamo", contact: "Contatti", quote: "Preventivo", cta: "Scrivici" },
  hero: {
    kicker: "Travel designer · Sud Tunisia · Sahara",
    season: "Stagione deserto: novembre → aprile",
    lines: ["Il deserto", "non si visita.", "Si attraversa."],
    sub: "Viaggi su misura in moto e in 4X4 tra le dune del Grande Erg Orientale, i ksour berberi e i laghi salati del sud tunisino.",
    ctaPrimary: "Scopri i tour",
    ctaSecondary: "WhatsApp",
    scroll: "Scorri",
    coords: "33°27′N · 9°01′E — Douz, porta del Sahara",
  },
  marquee: ["Douz", "Ksar Ghilane", "Chott el Jerid", "Tozeur", "Matmata", "Tataouine", "Grande Erg Orientale"],
  desertCall: {
    label: "Desert Call · Stagione 2026/2027",
    title: ["Desert", "Call"],
    season: "Stagione 2026/2027",
    route: "Tunisi · Djerba",
    text: "TSM WAY ti porta nel cuore del deserto tunisino con il Desert Call, un'avventura unica tra dune infinite, piste selvagge e autentica ospitalità locale. Un viaggio in moto, tra tradizione, natura e libertà.",
    claim: "Più di un viaggio, uno stile di vita.",
    pillars: [["Avventura", "Piste, dune e orizzonti che non finiscono."], ["Deserto", "Il Grande Erg Orientale, da Douz a Ksar Ghilane."], ["Amicizia", "Un gruppo di motociclisti, una sola carovana."], ["Tunisi · Djerba", "Dalla capitale all'isola, attraverso il sud."]],
    seasonLabel: "Stagione dei tour nel deserto",
    seasonRange: "Da novembre ad aprile",
    seasonText: "Nei mesi freschi il Sahara dà il meglio: giornate limpide, sabbia compatta e notti stellate. I tour nel deserto si organizzano da novembre ad aprile.",
    months: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    open: "Aperto", closed: "Pausa estiva",
    cta: "Richiedi il tuo posto",
    ctaWa: "Scrivici su WhatsApp",
  },
  moto: {
    index: "01",
    label: "Tour Moto",
    title: "Sabbia sotto le ruote, orizzonte davanti.",
    text: "Viaggi in moto unici tra dune del Sahara, oasi termali e antiche città della Tunisia. Esperienze su misura per Moto Club e gruppi di appassionati: strade panoramiche, off-road facile, cultura, gastronomia e avventura in totale sicurezza.",
    route: ["Civitavecchia", "Tunisi", "Douz", "Tembaine", "Ksar Ghilane", "Matmata", "Djerba", "Tunisi", "Civitavecchia"],
    routeLabel: "Itinerario tipo",
    items: [
      ["Partenza da Civitavecchia", "Traghetto GNV con la tua moto: si sbarca a Tunisi e si parte verso il sud, deserto e mare a due ruote."],
      ["Accompagnatore italiano e guida locale", "Un accompagnatore italiano al tuo fianco e una guida tunisina esperta del territorio, per tutto il viaggio."],
      ["Mezzo di supporto 4x4", "Assistenza al seguito con fuoristrada: bagagli, logistica, ricambi e sicurezza su ogni tappa."],
    ],
    tag: "Moto Club e gruppi",
  },
  itinerary: {
    types: { ferry: "Traghetto", road: "Strada", track: "Pista" },
    days: [
      ["Civitavecchia", "Tunisi", "ferry", "Imbarco sul traghetto GNV con la propria moto. Cena e notte a bordo, briefing del viaggio."],
      ["Tunisi", "Douz", "road", "Sbarco al mattino e trasferimento verso sud passando da Kairouan e Gabès. Sera alla porta del Sahara."],
      ["Douz", "Tembaine", "track", "Prima giornata di sabbia: piste e dune dell'erg fino al massiccio di Tembaine. Bivacco o campo tendato."],
      ["Tembaine", "Ksar Ghilane", "track", "Attraverso il Grande Erg Orientale fino all'oasi: bagno alla sorgente termale e tramonto al fortino romano."],
      ["Ksar Ghilane", "Matmata", "road", "Pista di collegamento e poi strada tra i villaggi berberi di montagna fino alle case troglodite."],
      ["Matmata", "Djerba", "road", "Discesa verso la costa e traversata sull'isola di Djerba: mare, Houmt Souk e un pomeriggio di riposo."],
      ["Djerba", "Tunisi", "road", "Rientro lungo la costa fino alla capitale. Imbarco serale sul traghetto."],
      ["Tunisi", "Civitavecchia", "ferry", "Navigazione di ritorno e arrivo in Italia. Fine del viaggio."],
    ],
  },
  map: { label: "Mappa delle tappe", title: "Dal Tirreno alle dune, e ritorno.", hint: "Scorri per seguire il viaggio", sea: "Tratta in traghetto", land: "Tappe in moto", day: "Giorno" },
  fourx4: {
    index: "02",
    label: "Tour 4X4",
    title: "Il Sahara a quattro ruote motrici.",
    text: "Spedizioni in fuoristrada per gruppi, coppie e famiglie. Traversate nel deserto profondo, notti in bivacco sotto un cielo senza luci e itinerari pensati intorno a te.",
    items: [
      ["Traversate nel deserto", "Dall'oasi di Ksar Ghilane alle dune del Grande Erg Orientale."],
      ["Bivacco sotto le stelle", "Campi tendati nel silenzio del Sahara, cucina locale e tè berbero."],
      ["Gruppi privati", "Con il tuo mezzo o con il nostro: programma, ritmo e tappe su misura."],
    ],
    tag: "Privato o di gruppo",
  },
  routes: {
    label: "Itinerari",
    title: "Le tappe leggendarie del sud.",
    hint: "Seleziona una tappa",
    list: [
      ["Douz", "La porta del Sahara: mercati, cammelli e le prime dune dorate."],
      ["Ksar Ghilane", "Oasi nel cuore dell'erg con sorgente termale e fortino romano."],
      ["Chott el Jerid", "Il grande lago salato: una pista dritta tra miraggi e cristalli di sale."],
      ["Tozeur", "Palmeti, canyon di montagna e architettura in mattoni."],
      ["Matmata", "Le case troglodite berbere scavate nella terra."],
      ["Tataouine", "Ksour fortificati e granai arroccati sulle colline."],
    ],
  },
  gallery: { label: "Galleria", title: "Luce del deserto.", close: "Chiudi" },
  about: {
    label: "Chi siamo",
    partner: "Il nostro partner in Tunisia",
    title: "TSM WAY è un travel designer che vive il deserto, non lo racconta soltanto.",
    text: "Progettiamo viaggi nel sud tunisino per motociclisti e appassionati di fuoristrada. Ogni itinerario nasce da una conversazione: cosa vuoi guidare, quanto vuoi spingerti, come vuoi sentirti la sera al bivacco.",
    values: [
      ["Su misura", "Nessun pacchetto standard: date, ritmo e percorso sono tuoi."],
      ["Sicurezza", "Mezzi d'appoggio, logistica e conoscenza del territorio."],
      ["Autenticità", "Ospitalità locale, oasi nascoste, cultura berbera."],
    ],
  },
  contact: {
    label: "Contatti",
    title: "Disegniamo il tuo prossimo viaggio.",
    text: "Raccontaci il tuo sogno di deserto: moto o 4X4, quando e con chi. Ti rispondiamo con una proposta su misura.",
    whatsapp: "Scrivici su WhatsApp",
    email: "Email",
    phone: "Telefono",
    whatsappTn: "WhatsApp Tunisia",
    facebook: "Facebook",
    instagram: "Instagram",
    waMsg: "Ciao TSM WAY, vorrei informazioni su un viaggio nel sud tunisino.",
  },
  quote: {
    label: "Preventivo",
    title: "Richiedi un preventivo su misura.",
    text: "Due minuti, poche righe. Ricevi una proposta con date, tappe e costi: via email e, se vuoi, direttamente su WhatsApp.",
    name: "Nome", namePh: "Il tuo nome",
    contact: "Email o telefono", contactPh: "nome@email.it oppure +39 …",
    tour: "Tipo di viaggio", tours: { moto: "Moto", "4x4": "4X4", both: "Moto + 4X4" },
    dates: "Date", dateFrom: "Dal", dateTo: "Al (facoltativo)",
    people: "Persone", notes: "Note", notesPh: "Livello di guida, moto, esigenze particolari…",
    submit: "Invia richiesta", hint: "Riceverai risposta entro 24 ore. Nessun impegno.",
    error: "Invio non riuscito. Riprova o scrivici su WhatsApp.",
    doneTitle: "Richiesta ricevuta.",
    doneText: "Grazie! Abbiamo ricevuto la tua richiesta via email. Per una risposta ancora più rapida, inviacela anche su WhatsApp: il messaggio è già pronto.",
    doneTextNoEmail: "Grazie! La tua richiesta è stata registrata. Per essere sicuro che arrivi subito, inviacela anche su WhatsApp: il messaggio è già pronto.",
    waBtn: "Invia su WhatsApp", another: "Nuova richiesta",
    waIntro: "Ciao TSM WAY, richiesta preventivo dal sito:",
  },
  footer: { rights: "Tutti i diritti riservati.", tagline: "Travel designer · Sud Tunisia", admin: "Area riservata" },
  pay: {
    deposit: "Paga l'acconto",
    note: "Acconto per bloccare il tuo posto. Il programma e il saldo si concordano poi con TSM WAY.",
    error: "Pagamento non riuscito. Riprova o scrivici su WhatsApp.",
    checking: "Verifica del pagamento…",
    successTitle: "Acconto ricevuto.",
    successText: "Grazie! Ti contatteremo a breve per definire insieme il tuo viaggio.",
    cancelTitle: "Pagamento annullato.",
    cancelText: "Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.",
    back: "Torna al sito",
  },
};

const fr = {
  nav: { desertCall: "Desert Call", moto: "Tour Moto", fourx4: "Tour 4X4", routes: "Itinéraires", gallery: "Galerie", about: "À propos", contact: "Contact", quote: "Devis", cta: "Écrivez-nous" },
  hero: {
    kicker: "Travel designer · Sud tunisien · Sahara",
    season: "Saison désert : novembre → avril",
    lines: ["Le désert", "ne se visite pas.", "Il se traverse."],
    sub: "Voyages sur mesure à moto et en 4X4 entre les dunes du Grand Erg Oriental, les ksour berbères et les lacs salés du sud tunisien.",
    ctaPrimary: "Découvrir les tours",
    ctaSecondary: "WhatsApp",
    scroll: "Défiler",
    coords: "33°27′N · 9°01′E — Douz, porte du Sahara",
  },
  marquee: ["Douz", "Ksar Ghilane", "Chott el Jérid", "Tozeur", "Matmata", "Tataouine", "Grand Erg Oriental"],
  desertCall: {
    label: "Desert Call · Saison 2026/2027",
    title: ["Desert", "Call"],
    season: "Saison 2026/2027",
    route: "Tunis · Djerba",
    text: "TSM WAY vous emmène au cœur du désert tunisien avec le Desert Call, une aventure unique entre dunes infinies, pistes sauvages et hospitalité locale authentique. Un voyage à moto, entre tradition, nature et liberté.",
    claim: "Plus qu'un voyage, un style de vie.",
    pillars: [["Aventure", "Pistes, dunes et horizons sans fin."], ["Désert", "Le Grand Erg Oriental, de Douz à Ksar Ghilane."], ["Amitié", "Un groupe de motards, une seule caravane."], ["Tunis · Djerba", "De la capitale à l'île, à travers le sud."]],
    seasonLabel: "Saison des tours dans le désert",
    seasonRange: "De novembre à avril",
    seasonText: "Aux mois frais, le Sahara donne le meilleur de lui-même : journées limpides, sable compact et nuits étoilées. Les tours dans le désert s'organisent de novembre à avril.",
    months: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
    open: "Ouvert", closed: "Pause estivale",
    cta: "Réservez votre place",
    ctaWa: "Écrivez-nous sur WhatsApp",
  },
  moto: {
    index: "01",
    label: "Tour Moto",
    title: "Le sable sous les roues, l'horizon devant.",
    text: "Des voyages à moto uniques entre dunes du Sahara, oasis thermales et villes antiques de Tunisie. Des expériences sur mesure pour Moto Clubs et groupes de passionnés : routes panoramiques, off-road facile, culture, gastronomie et aventure en toute sécurité.",
    route: ["Civitavecchia", "Tunis", "Douz", "Tembaine", "Ksar Ghilane", "Matmata", "Djerba", "Tunis", "Civitavecchia"],
    routeLabel: "Itinéraire type",
    items: [
      ["Départ de Civitavecchia", "Ferry GNV avec votre moto : débarquement à Tunis puis cap au sud, désert et mer sur deux roues."],
      ["Accompagnateur italien et guide local", "Un accompagnateur italien à vos côtés et un guide tunisien expert du terrain, pendant tout le voyage."],
      ["Véhicule d'assistance 4x4", "Assistance en 4x4 : bagages, logistique, pièces et sécurité à chaque étape."],
    ],
    tag: "Moto Clubs et groupes",
  },
  itinerary: {
    types: { ferry: "Ferry", road: "Route", track: "Piste" },
    days: [
      ["Civitavecchia", "Tunis", "ferry", "Embarquement sur le ferry GNV avec sa moto. Dîner et nuit à bord, briefing du voyage."],
      ["Tunis", "Douz", "road", "Débarquement le matin et route vers le sud par Kairouan et Gabès. Soirée à la porte du Sahara."],
      ["Douz", "Tembaine", "track", "Première journée de sable : pistes et dunes de l'erg jusqu'au massif de Tembaine. Bivouac ou camp de tentes."],
      ["Tembaine", "Ksar Ghilane", "track", "Traversée du Grand Erg Oriental jusqu'à l'oasis : bain à la source chaude et coucher de soleil au fortin romain."],
      ["Ksar Ghilane", "Matmata", "road", "Piste de liaison puis route entre les villages berbères de montagne jusqu'aux maisons troglodytes."],
      ["Matmata", "Djerba", "road", "Descente vers la côte et traversée vers l'île de Djerba : mer, Houmt Souk et un après-midi de repos."],
      ["Djerba", "Tunis", "road", "Retour le long de la côte jusqu'à la capitale. Embarquement le soir sur le ferry."],
      ["Tunis", "Civitavecchia", "ferry", "Navigation de retour et arrivée en Italie. Fin du voyage."],
    ],
  },
  map: { label: "Carte des étapes", title: "De la Tyrrhénienne aux dunes, et retour.", hint: "Faites défiler pour suivre le voyage", sea: "Traversée en ferry", land: "Étapes à moto", day: "Jour" },
  fourx4: {
    index: "02",
    label: "Tour 4X4",
    title: "Le Sahara en quatre roues motrices.",
    text: "Expéditions tout-terrain pour groupes, couples et familles. Traversées du désert profond, nuits en bivouac sous un ciel sans lumière et itinéraires pensés pour vous.",
    items: [
      ["Traversées du désert", "De l'oasis de Ksar Ghilane aux dunes du Grand Erg Oriental."],
      ["Bivouac sous les étoiles", "Campements dans le silence du Sahara, cuisine locale et thé berbère."],
      ["Groupes privés", "Avec votre véhicule ou le nôtre : programme, rythme et étapes sur mesure."],
    ],
    tag: "Privé ou en groupe",
  },
  routes: {
    label: "Itinéraires",
    title: "Les étapes légendaires du sud.",
    hint: "Choisissez une étape",
    list: [
      ["Douz", "La porte du Sahara : marchés, dromadaires et premières dunes dorées."],
      ["Ksar Ghilane", "Oasis au cœur de l'erg avec source thermale et fortin romain."],
      ["Chott el Jérid", "Le grand lac salé : une piste droite entre mirages et cristaux de sel."],
      ["Tozeur", "Palmeraies, canyons de montagne et architecture en briques."],
      ["Matmata", "Les maisons troglodytes berbères creusées dans la terre."],
      ["Tataouine", "Ksour fortifiés et greniers perchés sur les collines."],
    ],
  },
  gallery: { label: "Galerie", title: "Lumière du désert.", close: "Fermer" },
  about: {
    label: "À propos",
    partner: "Notre partenaire en Tunisie",
    title: "TSM WAY est un travel designer qui vit le désert, pas seulement le raconte.",
    text: "Nous concevons des voyages dans le sud tunisien pour motards et passionnés de tout-terrain. Chaque itinéraire naît d'une conversation : ce que vous voulez piloter, jusqu'où vous voulez aller, ce que vous voulez ressentir le soir au bivouac.",
    values: [
      ["Sur mesure", "Aucun forfait standard : dates, rythme et parcours vous appartiennent."],
      ["Sécurité", "Véhicules d'assistance, logistique et connaissance du terrain."],
      ["Authenticité", "Hospitalité locale, oasis cachées, culture berbère."],
    ],
  },
  contact: {
    label: "Contact",
    title: "Dessinons votre prochain voyage.",
    text: "Racontez-nous votre rêve de désert : moto ou 4X4, quand et avec qui. Nous vous répondons avec une proposition sur mesure.",
    whatsapp: "Écrivez-nous sur WhatsApp",
    email: "Email",
    phone: "Téléphone",
    whatsappTn: "WhatsApp Tunisie",
    facebook: "Facebook",
    instagram: "Instagram",
    waMsg: "Bonjour TSM WAY, je souhaite des informations sur un voyage dans le sud tunisien.",
  },
  quote: {
    label: "Devis",
    title: "Demandez un devis sur mesure.",
    text: "Deux minutes, quelques lignes. Recevez une proposition avec dates, étapes et tarifs : par e-mail et, si vous le souhaitez, directement sur WhatsApp.",
    name: "Nom", namePh: "Votre nom",
    contact: "E-mail ou téléphone", contactPh: "nom@email.fr ou +33 …",
    tour: "Type de voyage", tours: { moto: "Moto", "4x4": "4X4", both: "Moto + 4X4" },
    dates: "Dates", dateFrom: "Du", dateTo: "Au (facultatif)",
    people: "Personnes", notes: "Notes", notesPh: "Niveau de pilotage, moto, besoins particuliers…",
    submit: "Envoyer la demande", hint: "Réponse sous 24 heures. Sans engagement.",
    error: "Envoi impossible. Réessayez ou écrivez-nous sur WhatsApp.",
    doneTitle: "Demande reçue.",
    doneText: "Merci ! Nous avons bien reçu votre demande par e-mail. Pour une réponse encore plus rapide, envoyez-la aussi sur WhatsApp : le message est déjà prêt.",
    doneTextNoEmail: "Merci ! Votre demande est enregistrée. Pour être sûr qu'elle nous parvienne tout de suite, envoyez-la aussi sur WhatsApp : le message est déjà prêt.",
    waBtn: "Envoyer sur WhatsApp", another: "Nouvelle demande",
    waIntro: "Bonjour TSM WAY, demande de devis depuis le site :",
  },
  footer: { rights: "Tous droits réservés.", tagline: "Travel designer · Sud tunisien", admin: "Espace réservé" },
  pay: {
    deposit: "Payer l'acompte",
    note: "Acompte pour réserver votre place. Le programme et le solde se définissent ensuite avec TSM WAY.",
    error: "Le paiement a échoué. Réessayez ou écrivez-nous sur WhatsApp.",
    checking: "Vérification du paiement…",
    successTitle: "Acompte reçu.",
    successText: "Merci ! Nous vous contacterons rapidement pour définir votre voyage ensemble.",
    cancelTitle: "Paiement annulé.",
    cancelText: "Aucun montant n'a été débité. Vous pouvez réessayer quand vous voulez.",
    back: "Retour au site",
  },
};

const en = {
  nav: { desertCall: "Desert Call", moto: "Moto Tours", fourx4: "4X4 Tours", routes: "Itineraries", gallery: "Gallery", about: "About", contact: "Contact", quote: "Quote", cta: "Get in touch" },
  hero: {
    kicker: "Travel designer · Southern Tunisia · Sahara",
    season: "Desert season: November → April",
    lines: ["The desert", "isn't visited.", "It's crossed."],
    sub: "Tailor-made motorcycle and 4X4 journeys through the dunes of the Grand Erg Oriental, Berber ksour and the salt lakes of southern Tunisia.",
    ctaPrimary: "Explore the tours",
    ctaSecondary: "WhatsApp",
    scroll: "Scroll",
    coords: "33°27′N · 9°01′E — Douz, gateway to the Sahara",
  },
  marquee: ["Douz", "Ksar Ghilane", "Chott el Jerid", "Tozeur", "Matmata", "Tataouine", "Grand Erg Oriental"],
  desertCall: {
    label: "Desert Call · 2026/2027 Season",
    title: ["Desert", "Call"],
    season: "2026/2027 Season",
    route: "Tunis · Djerba",
    text: "TSM WAY takes you into the heart of the Tunisian desert with the Desert Call, a unique adventure between endless dunes, wild tracks and genuine local hospitality. A motorcycle journey through tradition, nature and freedom.",
    claim: "More than a trip, a way of life.",
    pillars: [["Adventure", "Tracks, dunes and horizons that never end."], ["Desert", "The Grand Erg Oriental, from Douz to Ksar Ghilane."], ["Friendship", "A group of riders, one caravan."], ["Tunis · Djerba", "From the capital to the island, across the south."]],
    seasonLabel: "Desert tour season",
    seasonRange: "November to April",
    seasonText: "In the cool months the Sahara is at its best: clear days, firm sand and starry nights. Desert tours run from November to April.",
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    open: "Open", closed: "Summer break",
    cta: "Claim your place",
    ctaWa: "Message us on WhatsApp",
  },
  moto: {
    index: "01",
    label: "Moto Tours",
    title: "Sand under the wheels, horizon ahead.",
    text: "Unique motorcycle journeys between Sahara dunes, thermal oases and the ancient towns of Tunisia. Tailor-made experiences for motorcycle clubs and groups of riders: scenic roads, easy off-road, culture, food and adventure in complete safety.",
    route: ["Civitavecchia", "Tunis", "Douz", "Tembaine", "Ksar Ghilane", "Matmata", "Djerba", "Tunis", "Civitavecchia"],
    routeLabel: "Sample route",
    items: [
      ["Departure from Civitavecchia", "GNV ferry with your own bike: land in Tunis and head south — desert and sea on two wheels."],
      ["Italian tour leader and local guide", "An Italian tour leader by your side and an expert Tunisian guide, for the whole trip."],
      ["4x4 support vehicle", "Off-road support along the route: luggage, logistics, spare parts and safety on every stage."],
    ],
    tag: "Clubs and groups",
  },
  itinerary: {
    types: { ferry: "Ferry", road: "Road", track: "Track" },
    days: [
      ["Civitavecchia", "Tunis", "ferry", "Boarding the GNV ferry with your own bike. Dinner and night on board, trip briefing."],
      ["Tunis", "Douz", "road", "Morning landing and ride south via Kairouan and Gabès. Evening at the gateway to the Sahara."],
      ["Douz", "Tembaine", "track", "First day of sand: tracks and erg dunes to the Tembaine massif. Bivouac or tented camp."],
      ["Tembaine", "Ksar Ghilane", "track", "Across the Grand Erg Oriental to the oasis: a dip in the hot spring and sunset at the Roman fort."],
      ["Ksar Ghilane", "Matmata", "road", "Link track then road through Berber mountain villages to the troglodyte houses."],
      ["Matmata", "Djerba", "road", "Down to the coast and across to Djerba island: sea, Houmt Souk and a restful afternoon."],
      ["Djerba", "Tunis", "road", "Back along the coast to the capital. Evening ferry boarding."],
      ["Tunis", "Civitavecchia", "ferry", "Return crossing and arrival in Italy. End of the trip."],
    ],
  },
  map: { label: "Route map", title: "From the Tyrrhenian to the dunes, and back.", hint: "Scroll to follow the journey", sea: "Ferry crossing", land: "Riding stages", day: "Day" },
  fourx4: {
    index: "02",
    label: "4X4 Tours",
    title: "The Sahara in four-wheel drive.",
    text: "Off-road expeditions for groups, couples and families. Deep desert crossings, bivouac nights under a sky without lights, and routes built around you.",
    items: [
      ["Desert crossings", "From the Ksar Ghilane oasis to the dunes of the Grand Erg Oriental."],
      ["Bivouac under the stars", "Tented camps in the Sahara's silence, local cuisine and Berber tea."],
      ["Private groups", "With your vehicle or ours: schedule, pace and stops made to measure."],
    ],
    tag: "Private or group",
  },
  routes: {
    label: "Itineraries",
    title: "The legendary stops of the south.",
    hint: "Select a stop",
    list: [
      ["Douz", "Gateway to the Sahara: markets, camels and the first golden dunes."],
      ["Ksar Ghilane", "An oasis in the heart of the erg with a hot spring and Roman fort."],
      ["Chott el Jerid", "The great salt lake: a straight track between mirages and salt crystals."],
      ["Tozeur", "Palm groves, mountain canyons and brick architecture."],
      ["Matmata", "Berber troglodyte homes carved into the earth."],
      ["Tataouine", "Fortified ksour and granaries perched on the hills."],
    ],
  },
  gallery: { label: "Gallery", title: "Desert light.", close: "Close" },
  about: {
    label: "About",
    partner: "Our partner in Tunisia",
    title: "TSM WAY is a travel designer who lives the desert, not just talks about it.",
    text: "We design journeys in southern Tunisia for riders and off-road lovers. Every itinerary starts with a conversation: what you want to ride, how far you want to push, how you want to feel at the bivouac at night.",
    values: [
      ["Tailor-made", "No standard packages: dates, pace and route are yours."],
      ["Safety", "Support vehicles, logistics and deep local knowledge."],
      ["Authenticity", "Local hospitality, hidden oases, Berber culture."],
    ],
  },
  contact: {
    label: "Contact",
    title: "Let's design your next journey.",
    text: "Tell us about your desert dream: motorcycle or 4X4, when and with whom. We'll reply with a tailor-made proposal.",
    whatsapp: "Message us on WhatsApp",
    email: "Email",
    phone: "Phone",
    whatsappTn: "WhatsApp Tunisia",
    facebook: "Facebook",
    instagram: "Instagram",
    waMsg: "Hi TSM WAY, I'd like information about a trip to southern Tunisia.",
  },
  quote: {
    label: "Quote",
    title: "Request a tailor-made quote.",
    text: "Two minutes, a few lines. Get a proposal with dates, stages and costs: by email and, if you like, straight on WhatsApp.",
    name: "Name", namePh: "Your name",
    contact: "Email or phone", contactPh: "name@email.com or +44 …",
    tour: "Trip type", tours: { moto: "Motorcycle", "4x4": "4X4", both: "Moto + 4X4" },
    dates: "Dates", dateFrom: "From", dateTo: "To (optional)",
    people: "People", notes: "Notes", notesPh: "Riding level, bike, special needs…",
    submit: "Send request", hint: "We reply within 24 hours. No commitment.",
    error: "Sending failed. Try again or message us on WhatsApp.",
    doneTitle: "Request received.",
    doneText: "Thank you! We've received your request by email. For an even faster reply, send it to us on WhatsApp too — the message is ready.",
    doneTextNoEmail: "Thank you! Your request has been recorded. To make sure it reaches us right away, send it on WhatsApp too — the message is ready.",
    waBtn: "Send on WhatsApp", another: "New request",
    waIntro: "Hi TSM WAY, quote request from the website:",
  },
  footer: { rights: "All rights reserved.", tagline: "Travel designer · Southern Tunisia", admin: "Admin area" },
  pay: {
    deposit: "Pay the deposit",
    note: "A deposit to secure your place. The programme and balance are then agreed with TSM WAY.",
    error: "Payment failed. Please try again or message us on WhatsApp.",
    checking: "Checking your payment…",
    successTitle: "Deposit received.",
    successText: "Thank you! We'll be in touch shortly to design your trip together.",
    cancelTitle: "Payment cancelled.",
    cancelText: "You have not been charged. You can try again anytime.",
    back: "Back to the site",
  },
};

export const translations = { it, fr, en };
